<template>
  <v-app>
    <template v-if="useAppLayout">
      <div class="app-layout">
        <div class="app-layout__content">
          <router-view />
        </div>
        <BottomNavigation />
      </div>
    </template>
    <router-view v-else />
    <BaseToast />
  </v-app>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BottomNavigation from '@/components/layout/BottomNavigation.vue';
import BaseToast from '@/components/ui/BaseToast.vue';

const route = useRoute();
const useAppLayout = computed(() => route.meta.layout === 'app');
</script>

<style>
@import '@/assets/css/style.scss';

.app-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: var(--an-cream);
}

.app-layout__content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  scrollbar-width: none;
}
.app-layout__content::-webkit-scrollbar { display: none; }

@media (max-width: 767px) {
  .app-layout { min-height: 100vh; }
  .app-layout__content { padding-bottom: var(--an-nav-h); }
}
</style>
